import { createRouter, createWebHistory } from 'vue-router'
import LoginView           from '@/views/LoginView.vue'
import ClientsView         from '@/views/ClientsView.vue'
import GalleriesView       from '@/views/GalleriesView.vue'
import PortfolioView       from '@/views/PortfolioView.vue'
import LibraryView         from '@/views/LibraryView.vue'
import ContactMessagesView from '@/views/ContactMessagesView.vue'
import SettingsView        from '@/views/SettingsView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/login', name: 'login', component: LoginView },

    // Legacy /dashboard redirect so bookmarks still work
    { path: '/',          redirect: '/clients' },
    { path: '/dashboard', redirect: '/clients' },

    { path: '/clients',          name: 'clients',          component: ClientsView,         meta: { requiresAuth: true } },
    { path: '/galleries',        name: 'galleries',        component: GalleriesView,       meta: { requiresAuth: true } },
    { path: '/portfolio',        name: 'portfolio',        component: PortfolioView,       meta: { requiresAuth: true } },
    { path: '/library',          name: 'library',          component: LibraryView,         meta: { requiresAuth: true } },
    { path: '/photos',           name: 'photos',           component: GalleriesView,       meta: { requiresAuth: true } },
    { path: '/contact-messages', name: 'contact-messages', component: ContactMessagesView, meta: { requiresAuth: true } },
    { path: '/settings',         name: 'settings',         component: SettingsView,        meta: { requiresAuth: true } },
  ],
})

router.beforeEach((to) => {
  const token = localStorage.getItem('adminToken')
  if (to.meta.requiresAuth && !token) return '/login'
  if (to.path === '/login' && token) return '/clients'
})

export default router
